import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const CustomerTypeFilter = ({ value = '', onChange }) => {
  const { customers } = useTranslatedMessages();
  const t = customers?.type_filter ?? {};
  const optionsText = t.options ?? {};
  const options = [
    { value: 'BUSINESS', label: optionsText.business ?? 'Business' },
    { value: 'INDIVIDUAL', label: optionsText.individual ?? 'Individual' },
  ];
  const selectedOption = options.find((option) => option.value === value) || null;

  const handleChange = (_, selected) => {
    onChange(selected?.value || null);
  };

  return (
    <Autocomplete
      value={selectedOption}
      options={options}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, optionValue) => option?.value === optionValue?.value}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t.label ?? 'Customer Type'}
          variant="outlined"
          size="small"
          sx={{ minWidth: 200 }}
        />
      )}
      clearOnBlur={false}
    />
  );
};

export default CustomerTypeFilter;
